
<div echarts [options]="options" class="demo-chart"></div>
<div class="center-div">
    <p class="center-text">Time</p>
</div>
